import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_SHIPPING_INSURANCE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * A component that renders the shipping insurance as a line item.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const LineItemShippingInsuranceMaybe = props => {
  const { lineItems, intl } = props;

  const insuranceLineItem = lineItems.find(
    item => item.code === LINE_ITEM_SHIPPING_INSURANCE && !item.reversal
  );

  return insuranceLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.shippingInsurance" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, insuranceLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

export default LineItemShippingInsuranceMaybe;
